<tt-page *ngIf="!!get">
    <tt-page-heading *ngIf="!!get.webpage_heading">{{ get.webpage_heading }}</tt-page-heading>
    <tt-card ttHeading="filter" ttAccordion ttRememberId="w_shopfloor.head">
        <div class="col-xs-12 col-md-4 p-5">
            <tt-select
                ttLabel="businessco"
                [(ttModel)]="get.businessco_no"
                (ttModelChange)="onBusinesscoNoChanged()"
                [ttData]="companies"
                ttDataId="businessco_no"
                ttDataName="company_name"
            ></tt-select>
            <tt-select ttLabel="factory_name" [(ttModel)]="get.factory_id" (ttModelChange)="onFactoryIdChanged()" [ttData]="factories" ttDataId="factory_id" ttDataName="factory_name"></tt-select>
            <tt-select
                ttLabel="operation"
                [(ttModel)]="get.operation_id"
                (ttModelChange)="onOperationIdChanged()"
                [ttData]="operations"
                ttDataId="item_id"
                ttDataName="item_name"
                ttClearValue=""
                ttShowClearButton
            >
            </tt-select>
            <tt-select
                ttLabel="equipment"
                [(ttModel)]="get.equipment_id"
                (ttModelChange)="onEquipmentIdChanged()"
                [ttData]="equipments"
                ttDataId="item_id"
                ttDataName="item_name"
                ttClearValue=""
                ttShowClearButton
            ></tt-select>
            <tt-date-range
                ttRememberId="w_shopfloor"
                ttLabel="date_fom_tom"
                [(ttStartDate)]="get.date_fom"
                [(ttEndDate)]="get.date_tom"
                [(ttInterval)]="get.dateselector_index"
                (ttModelChange)="onDateRangeChanged()"
            ></tt-date-range>
        </div>

        <div class="col-xs-12 col-md-4 p-5">
            <tt-input-number ttLabel="labour_no" [(ttModel)]="get.labour_no" (ttOnBlur)="onLabourNoChanged()" ttTextAlign="right"></tt-input-number>
            <tt-select ttLabel="labour" [(ttModel)]="get.labour_no" (ttModelChange)="onLabourNoChanged()" [ttData]="labourers" ttDataId="item_id" ttDataName="item_name"></tt-select>
            <tt-input ttLabel="selected_jobid" [(ttModel)]="get.selected_jobid" ttReadonly></tt-input>
            <tt-input ttLabel="selected_jobtype" [(ttModel)]="get.selected_jobtype" ttReadonly></tt-input>
            <tt-button
                *ngIf="get.show_button_start_selected_job === '1'"
                ttText="shopfloor_start_selected_job"
                (ttClick)="startJob()"
                [ttLoading]="startingJob"
                ttIcon="fas fa-solid fa-play"
                ttType="success"
            ></tt-button>
            <tt-button-goto
                *ngIf="get.stamped === '1' && +get.labour_no > 0"
                ttText="shopfloor_exit_day"
                ttGoto="trnewjobconf"
                [ttGotoParms]="{ labour_no: get.labour_no, argtype: 'exit', argvalue: '0' }"
                ttIcon="fa fa-solid fa-plus"
                ttType="danger"
                ttTextAlign="center"
            ></tt-button-goto>
            <tt-button-settings *ngIf="get.show_setting === '1'"></tt-button-settings>
        </div>

        <div class="col-xs-12 col-md-4 p-5">
            <tt-input [hidden]="!get.prod_id" ttLabel="prod_id" [(ttModel)]="get.prod_id" tt-change="get.prod_id = $value" ttReadonly></tt-input>
            <tt-input [hidden]="!get.prod_name" ttLabel="prod_name" [(ttModel)]="get.prod_name" ttReadonly></tt-input>
            <tt-image *ngIf="!!get.url_picture" ttLabel="picture" [ttSrc]="get.url_picture"></tt-image>
            <tt-input-number [hidden]="+(get.order_order_no ?? 0) <= 0" ttLabel="order_order_no" [(ttModel)]="get.order_order_no" ttTextAlign="right" ttReadonly></tt-input-number>
            <tt-input [hidden]="!get.stat_cust_name" ttLabel="stat_cust_name" [(ttModel)]="get.stat_cust_name" tt-change="get.stat_cust_name = $value" ttReadonly></tt-input>
        </div>
    </tt-card>

    <tt-tabs ttRememberId="w_shopfloor.gb_shopfloor_main" [(ttSelectedId)]="get.gb_shopfloor_main">
        <tt-tab ttId="POW" ttLabel="gb_shopfloor_main_pow"></tt-tab>
        <tt-tab ttId="ORDERS" ttLabel="gb_shopfloor_main_orders"></tt-tab>
    </tt-tabs>

    <tt-grid [hidden]="get.gb_shopfloor_main !== 'POW'" *ngIf="!!grid" [(ttOptions)]="grid" (ttCellClick)="onGridCellClick($event)"></tt-grid>
    <tt-grid [hidden]="get.gb_shopfloor_main !== 'ORDERS'" *ngIf="!!ordersGrid" [(ttOptions)]="ordersGrid" (ttCellClick)="onOrdersGridCellClick($event)"></tt-grid>
</tt-page>
